
<template>
  <v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
    <v-dialog v-model="permitted_dialog" max-width="400px">
      <v-card>
        <v-card-text>
          <div class="text-center">
            <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
            <p>{{message}}</p>
            <v-progress-circular
              :size="70"
              :width="2"
              :value="100"
              color="error"
              class="mb-4 mr-4"
            >
              <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
            </v-progress-circular>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
  <v-container v-else v-show="permitted != null" class="pt-0" fluid>
    <v-snackbar
      :value="showMessage()"
      multi-line
      color="#686868"
      top
    >
      {{message}}
    </v-snackbar>
    <v-card flat >
    <v-toolbar dense flat color="#2A353D">
      <v-toolbar-title class="white--text subtitle-1 font-weight-normal">{{heading}}</v-toolbar-title>
      <v-spacer/>
      <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
      <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>

      <v-progress-linear
        :active="loading"
        :indeterminate="loading"
        absolute
        bottom
        color="#81DBF6"
      ></v-progress-linear>
    </v-toolbar>
    </v-card>

    <v-alert
      class="my-2"
      dense text
      color="#2A353D"
    >
      <v-row align="center" class="mx-2 mb-3">
        <v-col class="py-0">
          <v-select
            @change="getTransactionHist()"
            filled rounded background-color="white" dense clearable
            hide-details
            v-model="parameters.CustodianID"
            :items="allCustodians.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
            class="mx-1"
            item-text="CustodianName"
            item-value="CustodianID"
            placeholder="----"
            :rules="TextFieldRules"
            label="Custodian"
          ></v-select>
        </v-col>
        <v-col class="py-0">
          <v-select
            @change="getTransactionHist()"
            filled rounded background-color="white" dense clearable
            hide-details
            v-model="parameters.AccountID"
            :items="Accounts"
            class="mx-1"
            :item-text="item => item.tblclient.Forename + ` ` + item.tblclient.MajorName +` - ` + item.AccountNumber"
            item-value="AccountID"
            placeholder="----"
            :rules="TextFieldRules"
            label="Account"
          ></v-select>          
        </v-col>
        <v-col class="py-0">
          <v-select
            filled rounded background-color="white" dense
            hide-details
            v-model="parameters.CurrencyID"
            :items="allCurrencies.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
            class="mx-1"
            @change="getTransactionHist()"
            item-text="CurrencyName"
            item-value="CurrencyID"
            placeholder="----"
            label="Currency"
          ></v-select>
        </v-col>
      </v-row>
      <v-row align="center" class="mx-2">
        <v-col class="py-0">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="parameters.StartDate"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="parameters.StartDate"
                class="mx-1"
                label="Start Date"
                append-icon="mdi-calendar-month"
                readonly placeholder="--/--/--"
                hide-details
                dense filled rounded background-color="white" color="#2A353D"
                :rules="TextFieldRules"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker @change="getTransactionHist()" color="#2A353D" v-model="parameters.StartDate" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn outlined small color="#2A353D" @click="menu = false">Cancel</v-btn>
            <v-btn outlined small color="#2A353D" @click="$refs.menu.save(parameters.StartDate)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="py-0">
          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            :return-value.sync="parameters.EndDate"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="parameters.EndDate"
                class="mx-1"
                label="End Date"
                append-icon="mdi-calendar-month"
                readonly placeholder="--/--/--"
                hide-details
                dense filled rounded background-color="white" color="#2A353D"
                :rules="TextFieldRules"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker @change="getTransactionHist()" color="#2A353D" v-model="parameters.EndDate" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn outlined small color="#2A353D" @click="menu2 = false">Cancel</v-btn>
            <v-btn outlined small color="#2A353D" @click="$refs.menu2.save(parameters.EndDate)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-alert>

    <v-sheet class="mt-4 elevation-12">
      <v-toolbar color="white" dark dense flat>
        <v-spacer/>
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" outlined small color="#2A353D" class="ml-2">
            EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
          </v-btn>
          </template>
          <v-list dense>
          <v-list-item class="ma-0 pa-0">
            <v-btn @click="generatePDF(false)" text small color="#2A353D">
              <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "transaction_history"
                type    = "xls"
                name    = "TransactionHistory.xls">
  
                <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
              </download-excel>
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "transaction_history"
                type    = "csv"
                name    = "TransactionHistory.csv">
  
                <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
              </download-excel>
            </v-btn>
          </v-list-item>
          </v-list>
        </v-menu>
        <v-btn @click="generatePDF(true)" outlined small color="#2A353D" class="ml-2" v-on="on">
          PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
        </v-btn>

        <template v-slot:extension>
          <v-tabs light color="#2A353D" v-model="tabs" fixed-tabs>
            <v-tabs-slider color="#2A353D"></v-tabs-slider>
            <v-tab>Contributions</v-tab>
            <v-tab>Withdrawals</v-tab>
            <v-tab>Purchase</v-tab>
            <v-tab>Sale</v-tab>
          </v-tabs>
        </template>
      </v-toolbar>

      <v-tabs-items v-model="tabs">
        <v-tab-item>
          <v-data-table
            :fixed-header="true"
            :headers="contribution_headers"
            :items="transaction_history.filter(t => t.Contribution != null && t.Contribution != '')"
            :height="390"
            hide-default-footer
            disable-pagination
          >
          </v-data-table>
        </v-tab-item>
        <v-tab-item>
          <v-data-table
            :fixed-header="true"
            :headers="withdrawal_headers"
            :items="transaction_history.filter(t => t.Withdrawal != null && t.Withdrawal != '')"
            :height="390"
            hide-default-footer
            disable-pagination
          >
          </v-data-table>
        </v-tab-item>
        <v-tab-item>
          <v-data-table
            :fixed-header="true"
            :headers="purchase_headers"
            :items="transaction_history.filter(t => t.Purchase != null && t.Purchase != '')"
            :height="390"
            hide-default-footer
            disable-pagination
          >
          </v-data-table>
        </v-tab-item>
        <v-tab-item>
          <v-data-table
            :fixed-header="true"
            :headers="sale_headers"
            :items="transaction_history.filter(t => t.Sale != null && t.Sale != '')"
            :height="390"
            hide-default-footer
            disable-pagination
          >
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>
    </v-sheet>
  </v-container>
</template>

<script>
import reportsService from '../services/reports.service';
import UserService from '../services/user.service';
import {mapGetters} from "vuex";
import jsPDF from 'jspdf';
import 'jspdf-autotable'

export default {
  data () {
    return {
      parameters: {},
      transaction_history: [],
      valid: true,
      loading: false,
      filter_dialog: false,
      search: '',
      message: '',
      menu: false,
      heading: "Transaction History",
      menu2: false,
      permitted: null,
      tabs: null,
      permitted_dialog: true,
      contribution_headers: [
        { text: 'Client', align: 'start', sortable: false, value: 'Client' },
        { text: 'Custodian', align: 'start', sortable: false, value: 'Custodian' },
        { text: 'Date', align: 'start', sortable: false, value: 'Date' },
        { text: 'Contribution Value', value: 'Contribution', sortable: false }
      ],
      withdrawal_headers: [
        { text: 'Client', align: 'start', sortable: false, value: 'Client' },
        { text: 'Date', align: 'start', sortable: false, value: 'Date' },
        { text: 'Withdrawal Value', value: 'Withdrawal', sortable: false }
      ],
      purchase_headers: [
        { text: 'Client', align: 'start', sortable: false, value: 'Client' },
        { text: 'Date', align: 'start', sortable: false, value: 'Date' },
        { text: 'Purchase Value', value: 'Purchase', sortable: false },
        { text: 'Maturity Date', value: 'MaturityDate', sortable: false }
      ],
      sale_headers: [
        { text: 'Client', align: 'start', sortable: false, value: 'Client' },
        { text: 'Date', align: 'start', sortable: false, value: 'Date' },
        { text: 'Sale Value', value: 'Sale', sortable: false }
      ],
    }
  },

  computed: {
    ...mapGetters([
      "currentImage",
      "allCustodians",
      "identity",
      "allCountries",
      "allCities",
      "currentSystemDate",
      "allClientAccounts",
      "allCurrencies"
    ]),

    currentUser() {
      return this.$store.state.auth.user;
    },

    Accounts(){
      return this.allClientAccounts.filter(a => a.tblclient.CustodianID == this.parameters.CustodianID)
    }
  },

  created(){
    this.parameters = {
      AccountID: 0,
      CustodianID: 0,
      StartDate: new Date(0).toISOString().substring(0, 10),
      EndDate: new Date().toISOString().substring(0, 10)
    }
    reportsService.getTransactionHist(this.parameters)
    .then(response => {
      this.transaction_history = response.data
    },
    error => {
    this.message =
      (error.response && error.response.data.message) ||
      error.message ||
      error.toString();
    })
  },

  methods: {
    async getTransactionHist() {
      if(this.parameters.AccountID == null || this.parameters.AccountID == ''){
        this.parameters.AccountID = 0
      }
      if(this.parameters.CustodianID == null || this.parameters.CustodianID == ''){
        this.parameters.CustodianID = 0
        this.parameters.AccountID = 0
      }
      if(this.parameters.CurrencyID == null || this.parameters.CurrencyID == ''){
        this.parameters.CurrencyID = 0
      }

      this.loading = true;
      reportsService.getTransactionHist(this.parameters)
      .then(response => {
        this.transaction_history = response.data;
        this.loading = false
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
        this.loading = false
      })
    },
    generatePDF(IsPrint) {
      const contribution_columns = [
        { title: 'Client', dataKey: 'Client' },
        { title: 'Custodian', dataKey: 'Custodian' },
        { title: 'Date', dataKey: 'Date' },
        { title: 'Contribution Value', dataKey: 'Contribution' }
      ];

      const withdrawal_columns = [
        { title: 'Client', dataKey: 'Client' },
        { title: 'Date', dataKey: 'Date' },
        { title: 'Withdrawal Value', dataKey: 'Withdrawal' }
      ];

      const purchase_columns = [
        { title: 'Client', dataKey: 'Client' },
        { title: 'Date', dataKey: 'Date' },
        { title: 'Purchase Value', dataKey: 'Purchase' },
        { title: 'Maturity Date', dataKey: 'MaturityDate' }
      ];

      const sale_columns = [
        { title: 'Client', dataKey: 'Client' },
        { title: 'Date', dataKey: 'Date' },
        { title: 'Sale Value', dataKey: 'Sale' }
      ];

      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()

        for (var i = 1; i <= pageCount; i++) {
          var imgData = 'data:image/png;base64,'+ this.currentImage[0].data;

          doc.addImage(imgData, 'PNG', 0.5, 0.28, 1.3, 0.7);
          doc.setPage(i)
          // text is placed using x, y coordinates
          doc.setFontSize(10).text(this.identity[0].OrgName, 6, 0.5);
          doc.setFontSize(6).text(this.identity[0].Phadd1, 6, 0.6);
          doc.setFontSize(6).text(this.allCities.filter(a => a.CityID == this.identity[0].PhCity).map(a => a.City)[0], 6, 0.7);
          doc.setFontSize(6).text(this.allCountries.filter(a => a.CountryId == this.identity[0].PhCountry).map(a => a.CountryName)[0], 6, 0.8);
          doc.setFontSize(6).text('email: ' + this.identity[0].OrgMail, 6, 0.9);
          doc.setFontSize(6).text('cell: ' + this.identity[0].OrgNumber, 6, 1.0);
          doc.setFontSize(10).text(this.heading, 0.5, 1.2);
          doc.setFontSize(8).text((this.parameters.CustodianID > 0? 'Custodian: ' + this.allCustodians.filter(a => a.CustodianID == this.parameters.CustodianID).map(a => a.CustodianName) + '        ' : '') + (this.parameters.AccountID > 0? 'Client: ' + this.Accounts.filter(a => a.AccountID == this.parameters.AccountID).map(a => a.tblclient.Forename) + ' ' + this.Accounts.filter(a => a.AccountID == this.parameters.AccountID).map(a => a.tblclient.MajorName) + '        ' : ''), 0.5, 1.4);
          // create a line under heading
          doc.setLineWidth(0.01).line(0.5, 1.7, 8, 1.7);
          doc.setLineWidth(0.01).line(0.5, 1.9, 8, 1.9);
          doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
            align: 'center'
          })
        }
      }

      let doc = new jsPDF({
        orientation: "potrait",
        unit: "in",
        format: "letter"
      });

      doc.setFont('helvetica');
      doc.setFontSize(5);

      if(this.transaction_history.filter(t => t.Contribution != null && t.Contribution != '').length > 0){
        doc.autoTable({
          columns: contribution_columns,
          body: this.transaction_history.filter(t => t.Contribution != null && t.Contribution != ''),
          margin: { left: 0.5, top: 1.7 },
          styles: {overflow: 'linebreak',
                  fontSize: 6},
          showHeader: 'everyPage',
          beforePageContent: function(data) {
            doc.setFontSize(8);
            doc.text("Contributions", 0.5, data.settings.margin.top - 0.1);
          },
          theme: 'plain'
        });        
      }
      if(this.transaction_history.filter(t => t.Withdrawal != null && t.Withdrawal != '').length > 0){
        doc.autoTable({
          startY: (doc.internal.pageSize.getHeight() - doc.autoTableEndPosY()) + doc.autoTableEndPosY(),
          columns: withdrawal_columns,
          body: this.transaction_history.filter(t => t.Withdrawal != null && t.Withdrawal != ''),
          margin: { left: 0.5, top: 1.7 },
          styles: {overflow: 'linebreak',
                  fontSize: 6},
          showHeader: 'everyPage',
          beforePageContent: function(data) {
            doc.setFontSize(8);
            doc.text("Withdrawals", 0.5, data.settings.margin.top - 0.1);
          },
          theme: 'plain'
        });
      }
      if(this.transaction_history.filter(t => t.Purchase != null && t.Purchase != '').length > 0){
        doc.autoTable({
          startY: (doc.internal.pageSize.getHeight() - doc.autoTableEndPosY()) + doc.autoTableEndPosY(),
          columns: purchase_columns,
          body: this.transaction_history.filter(t => t.Purchase != null && t.Purchase != ''),
          margin: { left: 0.5, top: 1.7 },
          styles: {overflow: 'linebreak',
                  fontSize: 6},
          showHeader: 'everyPage',
          beforePageContent: function(data) {
            doc.setFontSize(8);
            doc.text("Purchases", 0.5, data.settings.margin.top - 0.1);
          },
          theme: 'plain'
        })
      }
      if(this.transaction_history.filter(t => t.Sale != null && t.Sale != '').length > 0){
        doc.autoTable({
          startY: (doc.internal.pageSize.getHeight() - doc.autoTableEndPosY()) + doc.autoTableEndPosY(),
          columns: sale_columns,
          body: this.transaction_history.filter(t => t.Sale != null && t.Sale != ''),
          margin: { left: 0.5, top: 1.7 },
          styles: {overflow: 'linebreak',
                  fontSize: 6},
          showHeader: 'everyPage',
          beforePageContent: function(data) {
            doc.setFontSize(8);
            doc.text("Sales", 0.5, data.settings.margin.top - 0.1);
          },
          theme: 'plain'
        });      
      }

      addFooters(doc);
      if(IsPrint == true){
        doc.output('dataurlnewwindow');
      } else{
        doc.save('TransactionHistory.pdf')
      }
    },
    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },
    validate () {
      this.$refs.form.validate()
      return this.valid
    },

    reset () {
      this.$refs.form.reset()
    },
  },

  mounted () {
    UserService.isReports().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }
}
</script>

<style scoped>
.v-btn {
  outline: none
}
</style>